import React, {useEffect} from "react";
import clsx from "clsx";
import {useSelector} from "react-redux";

const PageLayout = ({children}) => {
    const isLoad = useSelector(({searchReducer}) => searchReducer.isLoad);
    const appSettings = useSelector(({rootReducer}) => rootReducer.baseSettings);
    const themeData = JSON.parse(appSettings.theme) || [];

    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        Object.entries(themeData).map((item, key) => {
            document.documentElement.style.setProperty(item[0], item[1]);
        });
    });

    return (
        <div style={{fontSize: '16px'}} className={clsx(`job-search`, isLoad && `job-search__blur`,)}>
            {children}
        </div>
    );
};

export default PageLayout;
